import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { accountDeletionTL, libraryTL } from './locales';

const i18nResources = {
  en: {
    translation: {
      // here we will place our translations...
      common: {
        signOutButton: 'SIGN OUT',
        helpButton: 'HELP',
      },
      ...accountDeletionTL.EN,
    },
    ...libraryTL.EN,
  },
  id: {
    translation: {
      // here we will place our translations...
      common: {
        signOutButton: 'SIGN OUT',
        helpButton: 'HELP',
      },
      ...accountDeletionTL.ID,
    },
    ...libraryTL.ID,
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: {
      lookupCookie: 'lang',
      caches: ['cookie'],
    },
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: i18nResources,
  });

export default i18n;
